import React from 'react';
import { Link } from 'react-router-dom';
import '././styles/ErrorPage.css';

function ErrorPage() {
  return (
    <div className="error-page-container">
      <div className="error-page-content">
        <div className="error-page-icon">
          <span className="error-404-number">404</span>
        </div>
        <h1 className="error-page-title">Oops! Page Not Found</h1>
        <p className="error-page-description">
          The page you are searching for might have been removed, 
          had its name changed, or is temporarily unavailable.
        </p>
        <Link to="/" className="error-page-home-link">
          Return to Landing Page
        </Link>
      </div>
    </div>
  );
}

export default ErrorPage;